import React, { useState } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import Image from 'next/image';

import { routes } from '@/infrastructure/const/routes';
import { Reciter } from '@/infrastructure/class/reciter';
import { EMPTY_COVER_IMAGE_PATH } from '@/infrastructure/const/empty-image-path';
import s from './styles.module.scss';

interface IRecitersCarouselProps {
  data: Reciter;
  className?: string;
  imageLoadingEager?: boolean;
}

const RecitersFeaturedCarouselItem: React.FC<IRecitersCarouselProps> = (
  props
) => {
  const { className, data, imageLoadingEager = true } = props;

  const [background] = useState<string>(
    !!data.featureCover
      ? data.featureCover.mediumUrl ||
        data.featureCover.optimizedUrl ||
        data.featureCover.smallUrl
      : EMPTY_COVER_IMAGE_PATH
  );

  const imageLoading = imageLoadingEager ? 'eager' : 'lazy';
  const carouselItemClassNames = classNames(s['carousel-item'], className);

  return (
    <Link
      className={carouselItemClassNames}
      href={`${routes.reciters}/${data.slug}`}
      prefetch={false}
      passHref
    >
      <Image
        className={s['image']}
        loading={imageLoading}
        alt={data.slug}
        src={background}
        fill
        sizes="(max-width: 600px) 100%, 300px"
        fetchPriority="high"
      />
      <p className={s['title']}>{data.titleEn}</p>
    </Link>
  );
};

export default RecitersFeaturedCarouselItem;
